import { isEqual } from 'lodash';
import { useCallback } from 'react';

import { AttributionDetails } from '@generated/gql/graphql';
import { useTrackingContext } from '@tracking/Provider/Context';
import { SignupApplicationEntity } from '@tracking/trackingEvents';
import { parseAttributionContext } from '@tracking/utils/parseAttributionContext';

const useUpdateAttributionTrackingContext = () => {
  const { setApplicationTrackingContext, applicationTrackingContext } =
    useTrackingContext();

  const updateAttributionContext = useCallback(
    (attribution: Nullable<AttributionDetails>) => {
      if (!applicationTrackingContext) {
        return;
      }

      const attributionContext = parseAttributionContext(attribution);

      if (!attributionContext) {
        return;
      }

      const updatedContext: SignupApplicationEntity = {
        ...applicationTrackingContext,
        ...attributionContext,
      };

      // Ensures that the context is not updated unnecessarily causing a re-render
      if (isEqual(updatedContext, applicationTrackingContext)) {
        return applicationTrackingContext;
      }

      setApplicationTrackingContext(updatedContext);

      return updatedContext;
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setApplicationTrackingContext]
  );

  return { updateAttributionContext };
};

export { useUpdateAttributionTrackingContext };
